module.exports = "/_next/static/images/RepeatPurchaseCampaignsMobile-22656e4669d8019160897c17e1657328.png";